import { useState } from "react";

const Contact = () => {
	const [form, setForm] = useState({ name: "", email: "", message: "" });

	const handleChange = (e) =>
		setForm({ ...form, [e.target.name]: e.target.value });

	const handleSubmit = (e) => {
		e.preventDefault();
		alert("Thanks for reaching out!");
	};

	return (
		<div className="bg-slate-950 h-full text-gray-400 flex flex-col items-center justify-center p-10 text-center">
			<h2 className="text-3xl font-semibold">Contact Us</h2>
			<div className="my-6 flex flex-col sm:flex-row gap-2 sm:gap-4">
				<p className="text-lg">Email: contact@icepyramid.ng</p>
				<p className="hidden sm:block">|</p>
				<p className="text-lg">Phone: +234 700-ICEPYRAMID</p>
			</div>

			<form className="space-y-4" onSubmit={handleSubmit}>
				<input
					type="text"
					name="name"
					placeholder="Your Name"
					className="bg-slate-900 w-full p-3 border- border-gray-800 rounded outline-none focus:border-slate-700 focus:ring-1 focus:ring-slate-700"
					value={form.name}
					onChange={handleChange}
					required
				/>
				<input
					type="email"
					name="email"
					placeholder="Your Email"
					className="bg-slate-900 w-full p-3 border- border-gray-800 rounded outline-none focus:border-slate-700 focus:ring-1 focus:ring-slate-700"
					value={form.email}
					onChange={handleChange}
					required
				/>
				<textarea
					name="message"
					placeholder="Your Message"
					className="bg-slate-900 w-full p-3 border- border-gray-800 rounded outline-none focus:border-slate-700 focus:ring-1 focus:ring-slate-700"
					rows="5"
					value={form.message}
					onChange={handleChange}
					required
				/>
				<button
					type="submit"
					className="bg-red-900 text-white px-6 py-3 rounded hover:bg-red-950"
				>
					Send Message
				</button>
			</form>
		</div>
	);
};

export default Contact;
